/**
 * @file 评分
 * @author Wanzhongyun
 */

import { useCallback, useEffect, useState } from 'react';
import * as H from 'history';

import { fetchSubmitRate } from '../../api/components/rateApi';

const useRateHooks = (location?: H.Location<any>) => {
    const [rateValue, setRateValue] = useState<number>(0);

    useEffect(() => {
        setRateValue(0);
    }, [location]);

    const submitRate = useCallback(async (value: number): Promise<void> => {
        setRateValue(value);
        fetchSubmitRate(value);
    }, []);

    return {
        rateValue,
        submitRate
    };
};

export default useRateHooks;
